import React from 'react';
import { Box, Typography, Link, styled, Divider } from '@mui/material';

const FooterContainer = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'onLoginPage',
})(({ theme, onLoginPage }) => ({
  backgroundColor: onLoginPage ? 'transparent' : theme.palette.background.default,
  color: theme.palette.text.secondary,
  padding: '24px 48px',
  textAlign: 'center',
  fontSize: '0.875rem',
  width: '100%',
  marginTop: 'auto',
}));

const FooterContent = styled(Box)({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  flexWrap: 'wrap',
  marginBottom: '8px',
});

const FooterLinksContainer = styled(Box)(({ theme }) => ({
  '& a': {
    color: theme.palette.primary.main,
    fontFamily: '"Proxima Nova"',
    textDecoration: 'none',
    '&:hover': {
      textDecoration: 'underline',
    },
  },
  '& a:not(:last-child)::after': {
    content: '"|"',
    margin: '0 12px',
    color: '#4299D4',
    pointerEvents: 'none',
  },
}));

const CopyrightNotice = styled(Typography)(({ theme }) => ({
  marginRight: '24px',
  color: theme.palette.primary.main,
  fontFamily: '"Proxima Nova"',
}));

const CompanyAttribution = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.secondary,
  fontFamily: '"Proxima Nova"',
  fontStyle: 'italic',
  fontSize: '0.875rem',
}));

const links = [
  { href: '/terms', text: 'Terms' },
  { href: '/privacy', text: 'Privacy' },
  { href: '/security', text: 'Security' },
  { href: '/status', text: 'Status' },
  { href: '/docs', text: 'Docs' },
  { href: '/contact', text: 'Contact' },
  { href: '/manage-cookies', text: 'Manage cookies' },
];

const Footer = ({ onLoginPage }) => {
  return (
    <FooterContainer component="footer" onLoginPage={onLoginPage}>
      <Divider sx={{ mb: 3, borderColor: '#5FBDF1' }} />
      <FooterContent>
        <CopyrightNotice variant="body2">© 2025 DevOps Buddy</CopyrightNotice>
        <FooterLinksContainer>
          {links.map((link) => (
            <Link key={link.text} href={link.href} variant="body2">
              {link.text}
            </Link>
          ))}
        </FooterLinksContainer>
      </FooterContent>
      <CompanyAttribution variant="body2">
        DevOps Buddy is a product from VaidhyaMegha Pvt. Ltd.
      </CompanyAttribution>
    </FooterContainer>
  );
};

export default Footer;
